import { useEffect, useState } from "react";
import axios from "@helpers/axios/private.axios";
import { isSuccessfulDepositTransaction } from "@helpers/walletTxStatus";

const DEPOSIT_HISTORY_QUERY = "operation=deposit&page=1&paginate=50";

const fetchDepositTransactions = async (path) => {
  const resp = await axios.get(`${path}?${DEPOSIT_HISTORY_QUERY}`);
  return resp?.data?.data ?? [];
};

export const useHasSuccessfulDeposit = (enabled) => {
  const [hasSuccessfulDeposit, setHasSuccessfulDeposit] = useState(false);
  const [loading, setLoading] = useState(Boolean(enabled));

  useEffect(() => {
    if (!enabled) {
      setHasSuccessfulDeposit(false);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    const checkDeposits = async () => {
      setLoading(true);

      try {
        const [fiatTransactions, cryptoTransactions] = await Promise.all([
          fetchDepositTransactions("/gateway/history/fiat/transactions"),
          fetchDepositTransactions("/gateway/history/crypto/transactions"),
        ]);

        const hasDeposit = [...fiatTransactions, ...cryptoTransactions].some(
          isSuccessfulDepositTransaction,
        );

        if (!cancelled) {
          setHasSuccessfulDeposit(hasDeposit);
        }
      } catch (error) {
        console.error(error);
        if (!cancelled) {
          setHasSuccessfulDeposit(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    checkDeposits();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { hasSuccessfulDeposit, loading };
};
